var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 12.44l6.98-6.83a.9.9 0 000-1.3.95.95 0 00-1.32 0l-6.98 6.84-6.99-6.83a.95.95 0 00-1.31 0 .9.9 0 000 1.29l6.98 6.83-6.98 6.83a.9.9 0 000 1.29.94.94 0 001.31 0l6.99-6.83 6.98 6.83a.94.94 0 001.32 0 .9.9 0 000-1.3l-6.99-6.82"
  })));
};
export default SvgCancel;